// src/services/anprEvent.api.ts
import { ApiResponse } from 'http/types/api-response'
import {
  AHCREvent,
  AHCREventCountResponse,
  AHCREventQueryParams,
} from '../types/ahcr-event.types'
import apiConfig from 'http/services/api.config'
import apiService from 'http/services/api.service'
import { HourlyEventCount } from 'domain/hourly-event-count'

class AHCREventApiService {
  private readonly baseUrl: string

  constructor() {
    this.baseUrl = apiConfig.endpoints.ahcrEvents
  }

  /**
   * Get all ANPR events with pagination and filtering
   */
  public async getANPREvents(
    params?: AHCREventQueryParams
  ): Promise<ApiResponse<AHCREvent[]>> {
    return apiService.post<ApiResponse<AHCREvent[]>>(
      this.baseUrl + `/${params?.clientId}`,
      params
    )
  }
  /**
   * Get all ANPR events with pagination and filtering
   */
  public async getAHCREventsCountByDate(
    params?: AHCREventQueryParams
  ): Promise<ApiResponse<AHCREventCountResponse>> {
    return apiService.post<ApiResponse<AHCREventCountResponse>>(
      this.baseUrl + `/events-count/${params?.clientId}`,
      params
    )
  }
  /**
   * Get AHCR event counts grouped by hour of day (0-23)
   */
  public async getAHCREventsHourlyCounts(
    params?: AHCREventQueryParams
  ): Promise<ApiResponse<HourlyEventCount[]>> {
    return apiService.post<ApiResponse<HourlyEventCount[]>>(
      this.baseUrl + `/hourly-counts/${params?.clientId}`,
      params
    )
  }
}

export const ahcrEventApiService = new AHCREventApiService()
export default ahcrEventApiService
